<template>
    <div class="_common_inviting_bind"></div>
</template>

<script >
/* eslint-disable @typescript-eslint/no-magic-numbers */
import { onMounted } from 'vue-demi';
import { BEHAVIOR_EVENT, InviterStatusEnum, VARIABLE_VALUE_MAP } from '../assets/constants';
import Api from '../assets/scripts/request';
import { UrlParser } from '../assets/utils/url';
const __sfc_main = {};
__sfc_main.props = {
  actSign: {
    type: String,
    default: ''
  },
  module: {
    type: String,
    default: ''
  },
  autoBind: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    debounce
  } = require('@futuweb/fego-bridge');
  const {
    useUser
  } = require('@fegobull/webapi').use;
  const {
    common: {
      env: {
        // 预渲染
        isPreRender
      }
    },
    store: {
      variable: {
        data
      }
    }
  } = require('@futuweb/fego-render');
  const props = __props;
  const emits = __ctx.emit;
  const {
    uid
  } = useUser();
  const handleBindStatus = async code => {
    switch (code) {
      case InviterStatusEnum.SUCCESS:
        emits(BEHAVIOR_EVENT.BIND_SUCCESS);
        break;
      // 绑定失败
      case InviterStatusEnum.FAILED:
        emits(BEHAVIOR_EVENT.BIND_FAIL);
        break;
      // 邀请人不能邀请自己
      case InviterStatusEnum.SELF_BOUND:
        emits(BEHAVIOR_EVENT.BIND_ITSELF);
        break;
      // 邀请人已绑定
      case InviterStatusEnum.ALREADY_BOUND:
        emits(BEHAVIOR_EVENT.BIND_HAS_INVITER);
        break;
      default:
        break;
    }
  };

  // 更新fego变量
  const updateFegoVariable = (key, value) => {
    data[key] = value;
  };
  const getInviterInfo = async () => {
    try {
      if (!uid) {
        return;
      }
      // status: 0未绑定，1已绑定
      const {
        status,
        inviterUid
      } = await Api.getInviterInfo({
        actSign: props.actSign,
        module: props.module
      });
      updateFegoVariable(VARIABLE_VALUE_MAP.inviteStatus, status);
      if (status) {
        if (inviterUid) {
          updateFegoVariable(VARIABLE_VALUE_MAP.inviteBindUid, inviterUid);
        }
        return;
      }
      if (props.autoBind) {
        bindInviter();
      }
    } catch (err) {
      console.log('getInviterInfo err', err);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const bindInviter = debounce(async () => {
    try {
      if (!uid) {
        return;
      }

      // 适配通用邀请关系与自定义邀请关系
      const urlParser = new UrlParser(location.href);
      const {
        inviter_def,
        global_content
      } = urlParser.query();
      let inviterDef = 0;
      // 优先使用inviter_def
      if (inviter_def) {
        inviterDef = inviter_def;
      } else if (global_content) {
        // 如果inviter_def不存在，则使用global_content中的invite
        const globalContent = JSON.parse(global_content);
        inviterDef = globalContent?.invite;
      }
      if (inviterDef) {
        const params = {
          inviterUid: Number(inviterDef),
          actSign: props.actSign,
          module: props.module
        };
        const data = await Api.bindInviter(params);
        console.log('data', data);
        handleBindStatus(data.status);
        updateFegoVariable(VARIABLE_VALUE_MAP.bindStatus, data?.status);
        updateFegoVariable(VARIABLE_VALUE_MAP.inviteBindUid, data?.inviterUid || 0);
        if (data?.status === InviterStatusEnum.SUCCESS) {
          updateFegoVariable(VARIABLE_VALUE_MAP.inviteStatus, 1);
        }
      }
    } catch (err) {
      console.log('bind err', err);
    }
  }, 1000);
  onMounted(() => {
    if (isPreRender) {
      return;
    }
    getInviterInfo();
  });

  // 暴露方法至fego调用
  return Object.assign({}, {
    bindInviter
  });
};
export default __sfc_main;
</script>

<style lang="less" scoped>
._common_inviting_bind {
    width: 7.5rem !important;
    height: auto !important;
}
</style>
